import PropertyList from '../controller'
import View from './view'
import HTML from '../../../../../html'
import {FilterValue, NeutralValue, FilterFieldTypesCollection, FilterField, FilterArray} from './filter-components'
import events from '../../../../../event-emitter'


export default class PropertyFilter extends PropertyList {

  constructor(finder) {
    super(finder);
    this.view = new View(this);

    this.title = "Sök och filter: ";

    this.filteredProps = PropertyProps.create();

    this.filters = {
      projekts: FilterArray.create(),
      objekts: FilterArray.create()
    };

    this.view.controller.setActiveTab('projekts')
  }

  processFilters() {
    this.processProjektsFilters().processObjektsFilters().updateProps();
    return this;
  }

  processProjektsFilters() {
    this.filteredProps.refillProjekts(this.filters.projekts.applyFilters(this.props.projekts));
    return this;
  }
  processObjektsFilters() {
    this.filteredProps.refillObjekts(this.filters.objekts.applyFilters(this.props.objekts));
    return this;
  }

  fillFilterControls() {
    this.filterControls = HTML("div")
      .classes("property-filters")
      .append(
        HTML("div")
          .classes("filter filter--objekts container")
          .append(this.objektFilters),
        HTML("div")
          .classes("filter filter--projekts container")
          .append(this.projektFilters)
      )
      .render();
    return this;
  }

  getFilteredProperty() {
    return this.filteredProps;
  }

  fillPropertyTabs() {
    super.fillPropertyTabs(this.getFilteredProperty());
    return this;
  }

  sortProps() {
    this.filteredProps = this.sortMethod.execute(this.filteredProps);
    return this;
  }

  manage(data) {
    this.reset();
    this.props = data;
    this.filteredProps = PropertyProps.create(data.projekts, data.objekts);
    this.view.initObjektsPagination();
    this.filters = {
      projekts: FilterArray.create(),
      objekts: FilterArray.create()
    };
    this.projektFilters = this._createProjektFilters(data.projekts);
    this.objektFilters = this._createObjektFilters(data.objekts);
    return this;
  }

  updateProps() {
    this
      .clearListControls()
      .clearPropertyTabs()
      .sortProps()
      .fillListControls()
      .fillPropertyTabs()
      .convertImagesToSVG();
  }

  render() {
    this
      .clearListControls()
      .clearPropertyTabs()
      .sortProps()
      .fillTitle()
      .fillFilterControls()
      .fillListControls()
      .fillPropertyTabs()
      .convertImagesToSVG();

    return [this.titleRoot, this.filterControls, this.listControlsRoot, this.propertyTabsRoot];
  }


  _createObjektFilters(objekts) {
    var defaults = {
      prisMin: 999999999999,
      prisMax: 0,
      priceRange: [50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 500000, 750000, 1000000, 1250000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000, 5000000, 6000000],
      avgiftMin: 999999999999,
      avgiftMax: 0,
      avgiftRange: [500, 1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000, 6000, 7000, 8000, 9000, 10000, 12500, 15000, 17500, 20000, 25000],
      status: [],
      tilltradeMin: new Date(),
      tilltradeMax: new Date(),
      tilltradeRange: [],
      rumMin: 999999999999,
      rumMax: 0,
      rumRange: [],
      storlekMin: 999999999999,
      storlekMax: 0,
      storlekRange: [],
      balkong: []
    };

    objekts.map(objekt => {
      if (objekt.props.price && objekt.props.price < defaults.prisMin) defaults.prisMin = objekt.props.price;
      if (objekt.props.price && objekt.props.price > defaults.prisMax) defaults.prisMax = objekt.props.price;

      if (objekt.props.fee && objekt.props.fee < defaults.avgiftMin) defaults.avgiftMin = objekt.props.fee;
      if (objekt.props.fee && objekt.props.fee > defaults.avgiftMax) defaults.avgiftMax = objekt.props.fee;

      if (objekt.props.area && objekt.props.area < defaults.storlekMin) defaults.storlekMin = objekt.props.area;
      if (objekt.props.area && objekt.props.area > defaults.storlekMax) defaults.storlekMax = objekt.props.area;

      if (objekt.props.rooms && objekt.props.rooms < defaults.rumMin) defaults.rumMin = objekt.props.rooms; else
      if (objekt.props.rooms && objekt.props.rooms > defaults.rumMax) defaults.rumMax = objekt.props.rooms;

      if (objekt.props.status && objekt.props.status.length > 0 && !defaults.status.includes(objekt.props.status))
        defaults.status.push(objekt.props.status);

      if (objekt.props.balcony1 && objekt.props.balcony1.length > 0 && !defaults.balkong.includes(objekt.props.balcony1))
        defaults.balkong.push(objekt.props.balcony1);
      if (objekt.props.balcony2 && objekt.props.balcony2.length > 0 && !defaults.balkong.includes(objekt.props.balcony2))
        defaults.balkong.push(objekt.props.balcony2);
    });

    defaults.prisMin = defaults.prisMin < defaults.prisMax || 0;
    defaults.rumMin = defaults.rumMin < defaults.rumMax || 0;
    defaults.storlekMin = defaults.storlekMin < defaults.storlekMax || 0;

    defaults.priceRange =
      ranger(defaults.prisMin, defaults.prisMax, 500000);
    defaults.avgiftRange =
      ranger(defaults.avgiftMin, defaults.avgiftMax, 500);
    defaults.storlekRange =
      ranger(defaults.storlekMin, defaults.storlekMax, 25);
    defaults.rumRange =
      ranger(defaults.rumMin, defaults.rumMax, 1);
    defaults.tilltradeRange =
      ranger(defaults.tilltradeMin.getTime(), defaults.tilltradeMax.getTime(), 7.884e+9);

    this.filters.objekts.add(
      FilterField.create("dropdown", "prisMin")
        .fillValues(FilterValue => {
          return defaults.priceRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Min priser")
        .defineExpression((p, state) => p.props.price >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.objekts.add(
      FilterField.create("dropdown", "prisMax")
        .fillValues(FilterValue => {
          return defaults.priceRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Max priser")
        .defineExpression((p, state) => p.props.price <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.objekts.add(
      FilterField.create("dropdown", "avgiftMin")
        .fillValues(FilterValue => {
          return defaults.avgiftRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Min avgift")
        .defineExpression((p, state) => p.props.fee >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.objekts.add(
      FilterField.create("dropdown", "avgiftMax")
        .fillValues(FilterValue => {
          return defaults.avgiftRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Max avgift")
        .defineExpression((p, state) => p.props.fee <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.objekts.add(
      FilterField.create("dropdown", "rumMin")
        .fillValues(FilterValue => {
          return defaults.rumRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Min rum")
        .defineExpression((p, state) => p.props.rooms >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.objekts.add(
      FilterField.create("dropdown", "rumMax")
        .fillValues(FilterValue => {
          return defaults.rumRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Max rum")
        .defineExpression((p, state) => p.props.rooms <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.objekts.add(
      FilterField.create("dropdown", "tilltradeMin")
        .fillValues(FilterValue => {
          return defaults.tilltradeRange.map(v => FilterValue.create(v, timestampToSeason(v)))
        })
        .setNeutral("Min tillträde")
        .defineExpression((p, state) => Date.parse(p.props.salesStartDate) >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.objekts.add(
      FilterField.create("dropdown", "tilltradeMax")
        .fillValues(FilterValue => {
          return defaults.tilltradeRange.map(v => FilterValue.create(v, timestampToSeason(v)))
        })
        .setNeutral("Max tillträde")
        .defineExpression((p, state) => Date.parse(p.props.salesEndDate) <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.objekts.add(
      FilterField.create("dropdown", "storlekMin")
        .fillValues(FilterValue => {
          return defaults.storlekRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Min storlek")
        .defineExpression((p, state) => p.props.area >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.objekts.add(
      FilterField.create("dropdown", "storlekMax")
        .fillValues(FilterValue => {
          return defaults.storlekRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Max storlek")
        .defineExpression((p, state) => p.props.area <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.objekts.add(
      FilterField.create("checkboxes", "status", false)
        .fillValues(FilterValue => {
          return defaults.status.map(v => {
            return v === "Till salu"
              ? FilterValue.create(v, v, true)
              : FilterValue.create(v);
          })
        })
        .defineExpression((p, state) => {
          return state instanceof Array
            ? state.includes(p.props.status)
            : [];
        })
        .bindTo("dofilter", this.processFilters.bind(this))
    );

    this.filters.objekts.add(
      FilterField.create("checkboxes", "balkong", false)
        .fillValues(FilterValue => {
          return defaults.balkong.map(v => FilterValue.create(v, v, true))
        })
        .defineExpression((p, state) => {
          return state instanceof Array
            ? state.includes(p.props.balcony1) || state.includes(p.props.balcony2)
            : [];
        })
        .bindTo("dofilter", this.processFilters.bind(this))
    );

    this.processObjektsFilters();

    return [
      createDropdownRangeGroup("Pris",
        this.filters.objekts.get("prisMin"), this.filters.objekts.get("prisMax")),
      createDropdownRangeGroup("Avgift",
        this.filters.objekts.get("avgiftMin"), this.filters.objekts.get("avgiftMax")),
      createDropdownRangeGroup("Antal rum",
        this.filters.objekts.get("rumMin"), this.filters.objekts.get("rumMax")),
      createDropdownRangeGroup("Tillträde",
        this.filters.objekts.get("tilltradeMin"), this.filters.objekts.get("tilltradeMax")),
      createDropdownRangeGroup("Storlek (BOA - m2)",
        this.filters.objekts.get("storlekMin"), this.filters.objekts.get("storlekMax")),
      createCheckboxesGroup("Lägenheter status", this.filters.objekts.get("status")),
      createCheckboxesGroup("Balkong och uteplats", this.filters.objekts.get("balkong")),
    ]
  }



  _createProjektFilters(projekts) {
    var defaults = {
      prisMin: 999999999999,
      prisMax: 0,
      priceRange: [50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 500000, 750000, 1000000, 1250000, 1500000, 2000000, 2500000, 3000000, 3500000, 4000000, 5000000, 6000000],
      status: [],
      tilltradeMin: new Date(),
      tilltradeMax: new Date(),
      tilltradeRange: [],
      rumMin: 999999999999,
      rumMax: 0,
      rumRange: [],
      storlekMin: 999999999999,
      storlekMax: 0,
      storlekRange: []
    };

    projekts.map(projekt => {
      if (projekt.props.minPrice && projekt.props.minPrice < defaults.prisMin) defaults.prisMin = projekt.props.minPrice;
      if (projekt.props.maxPrice && projekt.props.maxPrice > defaults.prisMax) defaults.prisMax = projekt.props.maxPrice;

      if (projekt.props.spaceMin && projekt.props.spaceMin < defaults.storlekMin) defaults.storlekMin = projekt.props.spaceMin;
      if (projekt.props.spaceMax && projekt.props.spaceMax > defaults.storlekMax) defaults.storlekMax = projekt.props.spaceMax;

      if (projekt.props.minRooms && projekt.props.minRooms < defaults.rumMin) defaults.rumMin = projekt.props.minRooms;
      if (projekt.props.maxRooms && projekt.props.maxRooms > defaults.rumMax) defaults.rumMax = projekt.props.maxRooms;

      if (projekt.props.status && projekt.props.status.length > 0 && !defaults.status.includes(projekt.props.status))
        defaults.status.push(projekt.props.status);

      let salesStart = Date.parse(projekt.props.salesStartDate),
        salesEnd = Date.parse(projekt.props.salesEndDate);

      if (salesStart < defaults.tilltradeMin && salesStart > new Date())
        defaults.tilltradeMin = new Date(Date.parse(projekt.props.salesStartDate));

      if (salesEnd > defaults.tilltradeMax && salesEnd > defaults.tilltradeMin)
        defaults.tilltradeMax = new Date(Date.parse(projekt.props.salesEndDate));
    });

    defaults.prisMin = defaults.prisMin < defaults.prisMax || 0;
    defaults.rumMin = defaults.rumMin < defaults.rumMax || 0;
    defaults.storlekMin = defaults.storlekMin < defaults.storlekMax || 0;

    defaults.priceRange =
      ranger(defaults.prisMin, defaults.prisMax, 500000);
    defaults.storlekRange =
      ranger(defaults.storlekMin, defaults.storlekMax, 25);
    defaults.rumRange =
      ranger(defaults.rumMin, defaults.rumMax, 1);
    defaults.tilltradeRange =
      ranger(defaults.tilltradeMin.getTime(), defaults.tilltradeMax.getTime(), 7.884e+9);

    this.filters.projekts.add(
      FilterField.create("dropdown", "prisMin")
        .fillValues(FilterValue => {
          return defaults.priceRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Min priser")
        .defineExpression((p, state) => inRange(p.props.minPrice, p.props.maxPrice, state, 99999999999))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.projekts.add(
      FilterField.create("dropdown", "prisMax")
        .fillValues(FilterValue => {
          return defaults.priceRange.map(v => FilterValue.create(v, v.toLocaleString("sv-SE")))
        })
        .setNeutral("Max priser")
        .defineExpression((p, state) => inRange(p.props.minPrice, p.props.maxPrice, -1, state))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.projekts.add(
      FilterField.create("dropdown", "rumMin")
        .fillValues(FilterValue => {
          return defaults.rumRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Min rum")
        .defineExpression((p, state) => inRange(p.props.minRooms, p.props.maxRooms, state, 99999999999))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.projekts.add(
      FilterField.create("dropdown", "rumMax")
        .fillValues(FilterValue => {
          return defaults.rumRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Max rum")
        .defineExpression((p, state) => inRange(p.props.minRooms, p.props.maxRooms, -1, state))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.projekts.add(
      FilterField.create("dropdown", "tilltradeMin")
        .fillValues(FilterValue => {
          return defaults.tilltradeRange.map(v => FilterValue.create(v, timestampToSeason(v)))
        })
        .setNeutral("Min tillträde")
        .defineExpression((p, state) => Date.parse(p.props.salesStartDate) >= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.projekts.add(
      FilterField.create("dropdown", "tilltradeMax")
        .fillValues(FilterValue => {
          return defaults.tilltradeRange.map(v => FilterValue.create(v, timestampToSeason(v)))
        })
        .setNeutral("Max tillträde")
        .defineExpression((p, state) => Date.parse(p.props.salesEndDate) <= state)
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.projekts.add(
      FilterField.create("dropdown", "storlekMin")
        .fillValues(FilterValue => {
          return defaults.storlekRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Min storlek")
        .defineExpression((p, state) => inRange(p.props.spaceMin, p.props.spaceMax, state, 99999999999))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );
    this.filters.projekts.add(
      FilterField.create("dropdown", "storlekMax")
        .fillValues(FilterValue => {
          return defaults.storlekRange.map(v => FilterValue.create(v))
        })
        .setNeutral("Max storlek")
        .defineExpression((p, state) => inRange(p.props.spaceMin, p.props.spaceMax, -1, state))
        .bindTo("dofilter", field => {
          field.state = field.getValue();
          this.processFilters();
        })
    );

    this.filters.projekts.add(
      FilterField.create("checkboxes", "status", false)
        .fillValues(FilterValue => {
          return defaults.status.map(v => FilterValue.create(v, v, true))
        })
        .defineExpression((p, state) => {
          return state instanceof Array
            ? state.includes(p.props.status)
            : [];
        })
        .bindTo("dofilter", this.processFilters.bind(this))
    );

    this.processProjektsFilters();

    return [
      createDropdownRangeGroup("Pris",
        this.filters.projekts.get("prisMin"), this.filters.projekts.get("prisMax")),
      createDropdownRangeGroup("Antal rum",
        this.filters.projekts.get("rumMin"), this.filters.projekts.get("rumMax")),
      createDropdownRangeGroup("Tillträde",
        this.filters.projekts.get("tilltradeMin"), this.filters.projekts.get("tilltradeMax")),
      createDropdownRangeGroup("Storlek (BOA - m2)",
        this.filters.projekts.get("storlekMin"), this.filters.projekts.get("storlekMax")),
      createCheckboxesGroup("Projekt status", this.filters.projekts.get("status"))
    ]
  }
}




function createDropdownRangeGroup(title, field1, field2) {
    return HTML("div")
        .classes("filter__entry")
        .append(
            HTML("h4").content(title),
            HTML("div").classes("filter__row").append(
                HTML("div").classes("filter__cell").append(field1.getMarkup()),
                HTML("div").classes("filter__cell").append(field2.getMarkup())
            )
        ).render();
}

function createCheckboxesGroup(title, field) {
    return HTML("div")
        .classes("filter__entry")
        .append(
            HTML("h4").content(title).render(),
            HTML("div").classes("filter__row").append(field.getMarkup())
        ).render();
}



function inRange(min, max, rangeMin, rangeMax) {
    return (min <= rangeMin && (max >= rangeMin && max <= rangeMax))
        || (  min >= rangeMin &&  max <= rangeMax)
        || (( min <= rangeMax &&  min <= max) && (max >= rangeMin && max >= min))
        || (( min <= rangeMax &&  min >= rangeMin) && max >= rangeMax);
}


function ranger(min = 0, max = 0, step = 100, limit = 1000) {
    let range = [Math.floor(min / step) * step, Math.ceil(max / step) * step],
        steps = (range[1] - range[0]) / step;
    if (!steps || steps < 0) return [];
    if (steps > limit) steps = limit;
    return Array.apply(null, new Array(steps + 1)).map((e, i) => range[0] + step * i).filter(n => n !== 0);
}

function dateToSeason(date) {
    let monthStr = (function (m) {
        if (m < 3 || m === 12) return "Vintern";
        else if (m < 6) return "Våren";
        else if (m < 9) return "Sommaren";
        else if (m < 12) return "Hösten";
    }(date.getMonth()));
    return monthStr + " " + date.getFullYear();
}

function timestampToSeason($str) {
    var d = new Date($str);
    return dateToSeason(d);
}


class PropertyProps {
    constructor(projekts, objekts) {
        this.projekts = projekts;
        this.objekts = objekts;
    }
    static create(...args) { return new PropertyProps(...args) }
    add(property) {
        if (property.proptype === "objekt") this.objekts.push(property);
        else if (property.proptype === "projekt") this.projekts.push(property);
        return this;
    }
    refillObjekts(objekts) {
        this.objekts = objekts;
        return this;
    }
    refillProjekts(projekts) {
        this.projekts = projekts;
        return this;
    }
}
